const filterRender = (val) => {
  if (!val && val !== 0) {
    return '--';
  }

  return val;
};

export function setDetailTable () {
  const detailTableCols = [
    {
      title: '商品图片',
      prop: 'image',
      tooltip: true,
      minWidth: '120px',
      slots: { default: 'imageList'},
    },
    {
      title: '商品编码（sku）',
      field: 'skuCode',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return row.outSkuCode ? filterRender(row.outSkuCode) : filterRender(row.skuCode);
      },
    },
    {
      title: '商品名称',
      field: 'goodsName',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.goodsName);
      },
    },
    {
      title: '规格',
      field: 'specification',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.specification);
      },
    },
    {
      title: '型号',
      field: 'model',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.model);
      },
    },
    {
      title: '所属品牌',
      field: 'brandName',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return filterRender(row.brandName);
      },
    },
    {
      title: '计量单位',
      field: 'unitName',
      tooltip: true,
      minWidth: '100px',
      formatter: ({ row }) => {
        return filterRender(row.unitName);
      },
    },
    {
      title: '销售数量',
      field: 'quantity',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return filterRender(row.quantity);
      },
    },
    {
      title: '销售单价（含税）',
      field: 'taxPrice',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return row.taxPrice === '' || row.taxPrice === null ? '--' : row.taxPrice.toLocaleString('en-US', { minimumFractionDigits: 2 });
      },
    },
    {
      title: '生产商',
      field: 'manufacturer',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.manufacturer);
      },
    },
    {
      title: '厂家编码',
      field: 'factoryCode',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.factoryCode);
      },
    },
    {
      title: '保修期',
      field: 'qualityAssPeriod',
      tooltip: true,
      minWidth: '150px',
      formatter: ({ row }) => {
        return `${row.qualityAssPeriod || ''}${row.qualityAssPeriodUnitName || ''}` || '--';
      },
    },
    {
      title: '是否医疗件',
      field: 'medicalFlag',
      tooltip: true,
      minWidth: '110px',
      formatter: ({ row }) => {
        return row['medicalFlag'] ? '是' : '否';
      },
    },
    {
      title: '产品注册证/备案凭证',
      field: 'certificateNumber',
      tooltip: true,
      minWidth: '180px',
      formatter: ({ row }) => {
        return filterRender(row.certificateNumber);
      },
    },
  ];

  return detailTableCols;
}
